import { render, staticRenderFns } from "./ListGroup.vue?vue&type=template&id=4806146a&scoped=true"
var script = {}
import style0 from "./ListGroup.vue?vue&type=style&index=0&id=4806146a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4806146a",
  null
  
)

export default component.exports